export { PieChart2 as default } from './PieChart2';
